import { Section } from "../utils/utils"
import React from "react"
import { StackedMarkdown } from "./StackedMarkdown"

export const GuideContentMarkdown = ({ section, pageIndex }: { section: Section; pageIndex: number }): JSX.Element => (
  <StackedMarkdown source={section?.pages[pageIndex]?.body} />
)
